import { render, staticRenderFns } from "./u-textarea-underlined.vue?vue&type=template&id=f7aaba3a&scoped=true"
import script from "./u-textarea-underlined.vue?vue&type=script&lang=js"
export * from "./u-textarea-underlined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7aaba3a",
  null
  
)

export default component.exports